export default function FilterIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={14}
        height={9}
        viewBox="0 0 14 9"
        fill="none"
      >
        <path
          d="M5.55556 8.5H8.44444V7.16667H5.55556V8.5ZM0.5 0.5V1.83333H13.5V0.5H0.5ZM2.66667 5.16667H11.3333V3.83333H2.66667V5.16667Z"
          fill="#048604"
        />
      </svg>
    </>
  )
}
